<app-dialog-container
  [title]="'Title.MainTitle.Cache'"
  [icon]="'icn-restore'"
  [zIndex]="Z_INDEX_CACHE_OVERLAY"
  [subtitle]="'Help.Description.Cache.Info'"
  [size]="'large'"
  (closeDialogClicked)="closeDialog()"
>
  @let cacheData = loadCacheOverview$ | async;
  @if (!isLoading) {
    <table>
      <thead>
        <tr>
          <th>
            <h5 class="!my-0">
              {{ "Table.Header.QueryType" | transloco }}
            </h5>
          </th>
          <th>
            <h5 class="!my-0">
              {{ "Table.Header.Date.General" | transloco }}
            </h5>
          </th>
          <th>
            <h5 class="!my-0">
              {{ "Table.Header.Time" | transloco }}
            </h5>
          </th>
          <th>
            <h5 class="!my-0">
              {{ "Module.Address.Country" | transloco }}
            </h5>
          </th>
          <th>
            <h5 class="!my-0">
              {{ "Table.Header.Details" | transloco }}
            </h5>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (cache of cacheData; track cache.Id) {
          <tr
            class="item text-p1b bg-primary-accumin-purple-05 cursor-pointer hover:bg-primary-accumin-purple-10 transition-colors duration-200"
            (click)="openCacheObject(cache)"
            onKeyPress="openCacheObject(cache)"
            [attr.data-testid]="`cache-item-${cache.Id}`"
          >
            <td class="rounded-l-lg">
              <div class="flex items-center gap-2">
                @switch (cache.ModuleId) {
                  @case (Modules.APS) {
                    <mat-icon svgIcon="icn-home" />
                    <span>
                      {{ "Title.MainTitle.ResidentialRealEstate.ModuleName" | transloco }}
                    </span>
                  }
                  @case (Modules.CommercialAVM) {
                    <mat-icon svgIcon="icn-store" />
                    <span>
                      {{ "Title.MainTitle.CommercialRealEstate.ModuleName" | transloco }}
                    </span>
                  }
                  @case (Modules.BPS) {
                    <mat-icon svgIcon="icn-flip_to_front" />
                    <span>
                      {{ "General.Plot" | transloco }}
                    </span>
                  }
                  @case (Modules.SpatialAnalysis) {
                    <mat-icon svgIcon="icn-perimeter" />
                    <span>
                      {{ "Title.MainTitle.SpatialAnalysis" | transloco }}
                    </span>
                  }

                  @case (Modules.Rvm) {
                    <mat-icon svgIcon="icn-home" />
                    <span>
                      {{ "Title.MainTitle.RvmRealEstate.Title" | transloco }}
                    </span>
                  }
                }
              </div>
            </td>
            <td>{{ timeService.getDate(cache.Time, null, optionService.locale()) }}</td>
            <td>{{ timeService.getTime(cache.Time) }}</td>
            <td>
              {{ cache.Address.Coordinate.Country.toUpperCase() }}
            </td>
            <td class="rounded-r-lg" data-testid="cache-item-details">
              {{ cache.details }}
            </td>
          </tr>
        } @empty {
          <div class="text-p1b w-full flex flex-row p-4 bg-primary-accumin-black-05 text-center rounded-lg text-primary-accumin-purple-100">
            {{ "General.NoData" | transloco }}
          </div>
        }
      </tbody>
    </table>
  } @else {
    <app-table-skeleton-loader [hasBerryHeader]="false" [numberOfRows]="7" [numberOfColumns]="5" />
  }
</app-dialog-container>
